import { render, staticRenderFns } from "./WidgetProductReviewsProductOptionsPc.vue?vue&type=template&id=eac3a8d0"
import script from "./WidgetProductReviewsProductOptionsPc.vue?vue&type=script&lang=js"
export * from "./WidgetProductReviewsProductOptionsPc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports